<div class="d-flex justify-content-center align-items-center min-vh-100 bg-light">

  <div class="card shadow-lg border-0 rounded-4 px-4 py-4" style="max-width: 520px; width: 100%;">

    <!-- LOGO -->
    <div class="text-center my-3">
      <img src="ExBe_monogram.png" alt="Logo" style="height: 115px;">
    </div>

    <!-- TITULO -->
    <h3 class="text-center fw-bold mb-1">Redefinir Senha</h3>
    <p class="text-center text-primary mb-4">Digite sua nova senha</p>

    <form [formGroup]="redefinirSenhaForm" (ngSubmit)="redefinirSenha()">

      <!-- SENHA -->
      <div class="mb-4 position-relative">
        <label for="senha" class="form-label fw-semibold">Nova Senha</label>

        <div class="input-group">
          <input 
            [type]="mostrarSenha ? 'text' : 'password'"
            id="senha"
            formControlName="senha"
            class="form-control"
            placeholder="Digite sua nova senha">

          <span class="input-group-text bg-white border-start-0">
            <i 
              class="bi fs-5 text-secondary" 
              [ngClass]="mostrarSenha ? 'bi-eye-slash' : 'bi-eye'"
              style="cursor: pointer;"
              (click)="toggleSenha()">
            </i>
          </span>
        </div>

        <small *ngIf="redefinirSenhaForm.get('senha')?.invalid && redefinirSenhaForm.get('senha')?.touched" class="text-danger">
          *Senha é obrigatória
        </small>
      </div>

      <!-- CONFIRMAR SENHA -->
      <div class="mb-5 position-relative">
        <label for="confirmarSenha" class="form-label fw-semibold">Confirmar Senha</label>

        <div class="input-group">
          <input 
            [type]="mostrarConfirmar ? 'text' : 'password'"
            id="confirmarSenha"
            formControlName="confirmarSenha"
            class="form-control"
            placeholder="Digite novamente sua nova senha">

          <span class="input-group-text bg-white border-start-0">
            <i 
              class="bi fs-5 text-secondary" 
              [ngClass]="mostrarConfirmar ? 'bi-eye-slash' : 'bi-eye'"
              style="cursor: pointer;"
              (click)="toggleConfirmar()">
            </i>
          </span>
        </div>

        <small *ngIf="redefinirSenhaForm.get('confirmarSenha')?.invalid && redefinirSenhaForm.get('confirmarSenha')?.touched" class="text-danger">
          *Confirmação de senha é obrigatória
        </small>

        <small *ngIf="redefinirSenhaForm.hasError('senhasNaoCoincidem') && redefinirSenhaForm.get('confirmarSenha')?.touched" class="text-danger d-block">
          *As senhas não coincidem
        </small>
      </div>

      <!-- BOTÃO -->
      <button 
        class="btn btn-dark w-100 py-2 fw-bold rounded-3 mb-1" 
        type="submit" 
        [disabled]="enviando">
        Salvar
      </button>

    </form>

  </div>

  <!-- LOADING -->
  <div class="loading-overlay-fullscreen" *ngIf="enviando">
    <div class="loading-spinner">
      <div class="spinner"></div>
      <p>{{ mensagemLoading }}</p>
    </div>
  </div>

</div>
